import PropTypes from "prop-types";
import React from "react";

import AppCrashFallback from "./AppCrashFallback";

/**
 * Root-level error boundary that catches catastrophic failures
 * during app initialization (e.g., provider errors).
 */
export default class RootErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("RootErrorBoundary caught:", error, errorInfo);

    // Report to Sentry if available
    if (window.Sentry?.captureException) {
      window.Sentry.captureException(error, {
        extra: {
          ...errorInfo,
          boundaryName: "RootErrorBoundary",
        },
      });
    }
  }

  render() {
    if (this.state.error) {
      return <AppCrashFallback error={this.state.error} />;
    }

    return this.props.children;
  }
}
